export const offsetMap = {
    '-720': 'Etc/GMT+12',
    '-660': 'Pacific/Pago Pago',
    '-600': 'Pacific/Honolulu',
    '-540': 'America/Anchorage',
    '-480': 'America/Los Angeles',
    '-420': 'America/Denver',
    '-360': 'America/Chicago',
    '-300': 'America/New York',
    '-240': 'America/Halifax',
    '-210': 'America/St Johns',
    '-180': 'America/Argentina/Buenos Aires',
    '-120': 'America/Noronha',
    '-60': 'Atlantic/Azores',
    0: 'Etc/UTC',
    60: 'Europe/London',
    120: 'Europe/Berlin',
    180: 'Europe/Moscow',
    210: 'Asia/Tehran',
    240: 'Asia/Dubai',
    270: 'Asia/Kabul',
    300: 'Asia/Karachi',
    330: 'Asia/Kolkata',
    345: 'Asia/Kathmandu',
    360: 'Asia/Dhaka',
    390: 'Asia/Rangoon',
    420: 'Asia/Bangkok',
    480: 'Asia/Shanghai',
    525: 'Australia/Eucla',
    540: 'Asia/Tokyo',
    570: 'Australia/Darwin',
    600: 'Australia/Brisbane',
    630: 'Australia/Adelaide',
    660: 'Australia/Sydney',
    690: 'Australia/Lord Howe',
    720: 'Pacific/Auckland',
    765: 'Pacific/Chatham',
    780: 'Pacific/Tongatapu',
    840: 'Pacific/Kiritimati'
  };